<template>
	<div v-if="statistics">
		<el-row :gutter="20">
			<el-col :span="6">
				<el-statistic group-separator="," :precision="2"
					:value="statistics.errorpercent?parseFloat(statistics.errorpercent):0"
					title="异常占比(%)"></el-statistic>
			</el-col>
		</el-row>
	</div>
</template>
<style>

</style>

<script>
	export default {
		name: '',
		props: {
			sourcedata: {
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				statistics: null,
			}
		},
		watch: {

		},
		mounted() {
			this.init()
		},
		computed: {

		},
		methods: {
			init() {
				if (this.sourcedata) {	
					if(this.sourcedata.total2){
						this.statistics = {
							errorpercent: (this.sourcedata.total / this.sourcedata.total2 * 100).toFixed(2)
						}
					}
				}
			}
		},
		components: {

		}
	}
</script>